import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-google-drive-login',
  templateUrl: './google-drive-login.component.html',
  styleUrls: ['./google-drive-login.component.scss']
})
export class GoogleDriveLoginComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {

  }
}
